import NiceModal, { useModal, antdModal } from "@ebay/nice-modal-react";
import AddEvent, { type IAddEventProps } from "@/components/AddEvent/index.jsx";
import VerdantProvider from "@/components/VerdantProvider.jsx";
import { toast } from "sonner";

import { Sheet } from "react-modal-sheet";
import {
	IonPicker,
	IonPickerColumn,
	IonPickerColumnOption,
} from "@ionic/react";
import { Button } from "@heroui/react";
import { memo, useMemo, useState } from "react";
import isEqual from "react-fast-compare";
import { getDataService } from "../../service.js";
import { useMemoizedFn, useRequest } from "ahooks";
import dayjs from "dayjs";
import { hooks } from "@/store.js";
import showErrMessage from "@/utils/showErrMessage.js";
import { planDetailEvent } from "../../utils/event.js";

const Content = memo(
	({
		planId,
		defaultValue,
		onClose,
		id,
		onChange,
	}: {
		planId: string;
		defaultValue: string;
		onClose: () => void;
		id: string;
		onChange: (value: string) => void;
	}) => {
		const { data } = useRequest(async () =>
			planId ? await getDataService({ id: planId }) : undefined,
		);

		const dayList = useMemo(() => {
			const startTime = dayjs(data?.startTime).startOf("day");
			const endTime = dayjs(data?.endTime).endOf("day");
			const diffDay = endTime.diff(startTime, "day") + 1;

			return [
				{ label: "总览" },
				...[...new Array(diffDay)].map((i, index) => {
					const date = startTime.add(index, "day");
					const dateText = date.format("YYYY-MM-DD");
					return {
						label: dateText,
					};
				}),
			];
		}, [data]);

		const [value, setValue] = useState(defaultValue);

		// const client = hooks.useClient();

		return (
			<>
				<b className="text-gray-800 text-2xl block px-4">你想移动至哪一天</b>
				<IonPicker>
					<IonPickerColumn
						value={value}
						onIonChange={(e) => {
							if (!e.target.value) return;
							setValue(e.target.value as string);
						}}
					>
						{dayList.map((i) => (
							<IonPickerColumnOption value={i.label} key={i.label}>
								{i.label}
							</IonPickerColumnOption>
						))}
					</IonPickerColumn>
				</IonPicker>

				<Button
					radius="full"
					onPress={async () => {
						if (!value) return;
						try {
							await onChange(value);

							setTimeout(() => {
								planDetailEvent.emit("requestRefresh");
							}, 500); // NOTICE: 不确定为什么要延迟？

							onClose();
						} catch (err) {
							showErrMessage(err);
						}
					}}
					className="bg-black mt-2 text-white !px-0 w-16  h-16 mx-auto min-w-0"
				>
					<i className="ic-round md-done text-4xl " />
				</Button>
				<div className="h-4" />
			</>
		);
	},
	isEqual,
);
const MoveTo = NiceModal.create(
	(props: {
		planId: string;
		defaultValue: string;
		id: string;
		onChange: (value: string) => void;
	}) => {
		const modal = useModal();
		const handleClose = useMemoizedFn(() => {
			modal.hide();
			setTimeout(() => {
				modal.remove();
			}, 500);
		});

		return (
			<VerdantProvider>
				<Sheet
					isOpen={modal.visible}
					onClose={handleClose}
					detent="content-height"
					disableScrollLocking
					style={{ zIndex: 50 }}
				>
					<Sheet.Container className="!rounded-t-3xl  ">
						<Sheet.Header />
						<Sheet.Content className="pb-safe">
							<Content {...props} onClose={handleClose} />
						</Sheet.Content>
					</Sheet.Container>
					<Sheet.Backdrop
						className="!bg-black/70"
						onTap={(e) => {
							modal.hide();
							setTimeout(() => {
								modal.remove();
							}, 500);
						}}
					/>
				</Sheet>
			</VerdantProvider>
		);
	},
);

export default MoveTo;
